import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useMinicrmMigrationStore } from '../../../store/minicrmMigrationStore';
import type { MinicrmProposal } from '../../../types/minicrmMigration';

interface Props { proposal: MinicrmProposal; onClose: () => void; }

export function ChangeMatchModal({ proposal, onClose }: Props) {
  const { searchPersons, decideContact } = useMinicrmMigrationStore();
  const [q, setQ] = useState('');
  const [results, setResults] = useState<Array<{ id: string; firstName: string; lastName: string; email: string | null }>>([]);

  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(async () => {
      if (q.length >= 2) {
        const r = await searchPersons(q);
        if (!cancelled) setResults(r);
      } else {
        setResults([]);
      }
    }, 200);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q, searchPersons]);

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md p-4" role="dialog" aria-modal="true">
        <div className="flex items-center justify-between mb-3">
          <div className="font-medium">Pick a different Main Person</div>
          <button type="button" onClick={onClose}><X className="h-4 w-4" /></button>
        </div>
        <div className="text-xs text-gray-500 mb-2">
          For Mini contact <strong>{proposal.miniContactSnapshot.firstName} {proposal.miniContactSnapshot.lastName}</strong>
        </div>
        <input
          autoFocus
          className="w-full border rounded px-3 py-2 text-sm"
          placeholder="Search by name or email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <div className="mt-3 max-h-64 overflow-y-auto divide-y">
          {results.map((r) => (
            <button
              type="button"
              key={r.id}
              className="w-full text-left px-3 py-2 hover:bg-gray-50 text-sm"
              onClick={async () => { await decideContact(proposal.id, 'CHANGED', r.id); onClose(); }}
            >
              <div className="font-medium">{r.firstName} {r.lastName}</div>
              <div className="text-xs text-gray-500">{r.email ?? '—'}</div>
            </button>
          ))}
          {q.length >= 2 && results.length === 0 && (
            <div className="px-3 py-2 text-sm text-gray-500">No matches.</div>
          )}
        </div>
      </div>
    </div>
  );
}
